import ajaychaturvedi from "./../../assets/Past Events/ajay-chaturvedi.jpg";
import ashishbeergi from "./../../assets/Past Events/ashish-beergi.jpg";
import ashokramachandran from "./../../assets/Past Events/ashok-ramachandran.jpg";
import dipakbharali from "./../../assets/Past Events/dipak-bharali.jpg";
import pareshgupta from "./../../assets/Past Events/paresh-gupta.jpg";
import pawanrai from "./../../assets/Past Events/pawan-rai.jpg";
import yashbhatt from "./../../assets/Past Events/yash-bhatt.jpg";
// import ajaychaturvedi from "./../../assets/Past Events/ajay-chaturvedi.jpg";
// import ajaychaturvedi from "./../../assets/Past Events/ajay-chaturvedi.jpg";
// import ajaychaturvedi from "./../../assets/Past Events/ajay-chaturvedi.jpg";
// import ajaychaturvedi from "./../../assets/Past Events/ajay-chaturvedi.jpg";
// import ajaychaturvedi from "./../../assets/Past Events/ajay-chaturvedi.jpg";
// import ajaychaturvedi from "./../../assets/Past Events/ajay-chaturvedi.jpg";
// import ajaychaturvedi from "./../../assets/Past Events/ajay-chaturvedi.jpg";
// import ajaychaturvedi from "./../../assets/Past Events/ajay-chaturvedi.jpg";

export const PastEventsData = [
    {
        index: 0,
        title: "THE SOLUTION ROOM",
        guestimg: ajaychaturvedi,
        date: "9th July 2021",
        time: "8:00 PM",
        guest: "Ajay Chaturvedi",
        desgn1: "Founder",
        desgn2: "HarVa",
        ytlink: "https://youtu.be/d3wSKEBfhec"
    },
    {
        index: 1,
        title: "A PIECE OF MIND",
        guestimg: pareshgupta,
        date: "10th July 2021",
        time: "5:00 PM",
        guest: "Paresh Gupta",
        desgn1: "Founder & CEO",
        desgn2: "GCEC",
        ytlink: "https://youtu.be/WMaXoNsTTUc"
    },
    {
        index: 2,
        title: "A TRIP TO FINSHOTS",
        guestimg: pawanrai,
        date: "11th July 2021",
        time: "11:00 AM",
        guest: "Pawan Kumar Rai",
        desgn1: "Co-Founder",
        desgn2: "Finshots",
        ytlink: "https://youtu.be/zrtQ0FEwGHc"
    },
    {
        index: 3,
        title: "FIRESIDE CHAT",
        guestimg: ashishbeergi,
        date: "10th July 2021",
        time: "10:00 AM",
        guest: "Aashish Beergi",
        desgn1: "Founder",
        desgn2: "Mash Project Foundation",
        ytlink: "https://youtu.be/W7g_7Q5bC34"
    },
    {
        index: 4,
        title: "SOLUTION BREWERY",
        guestimg: yashbhatt,
        date: "9th July 2021",
        time: "4:30 PM",
        guest: "Yash Bhatt",
        desgn1: "Founder",
        desgn2: "Brook & Blooms",
        ytlink: "https://youtu.be/aVnqeRv3Xwc"
    },
    {
        index: 5,
        title: "SOLUTION BREWERY",
        guestimg: dipakbharali,
        date: "9th July 2021",
        time: "4:30 PM",
        guest: "Dipak Bharali",
        desgn1: "Consultant",
        desgn2: "Grassroot Innovator",
        ytlink: "https://youtu.be/aVnqeRv3Xwc"
    },
    {
        index: 6,
        title: "CLOSING CEREMONY",
        guestimg: ashokramachandran,
        date: "11th July 2021",
        time: "7:00 PM",
        guest: "Ashok Ramachandran",
        desgn1: "CEO",
        desgn2: "Schindler India",
        ytlink: "https://youtu.be/aGqBOFJ29WE"
    }
]